import { Chip, Grid, InputLabel, OutlinedInput, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import Modal, { CommonModalProps } from "..";
import { DbInvoiceExpenseInfos } from "../../../Core/Api/Types/db-invoice-expense-infos";
import DataTable, { CellSize } from "../../Table/table";
import { GridColDef } from "@mui/x-data-grid";
import { UserHasAcl } from "../../../Utils/helpers";
import { AclTypes } from "../../../Core/Api/Types/acl-types";
import OrderItemPanel from "../../Panels/OrderItemPanel/order-item-panel";
import { useTranslation } from "react-i18next";
import { ExpenseTag } from "../../../Core/Api/Types/expense-tag";

export type ModalBillingExpenseElementProps = {
    expense: DbInvoiceExpenseInfos;
};

export type ModalBillingExpenseProps = CommonModalProps<ModalBillingExpenseElementProps>;

const ModalBillingExpense = React.forwardRef<any, ModalBillingExpenseProps>((props, ref) => {
    const { t } = useTranslation();
    const { closeModal, ...modalProps } = props;
    const { expense } = modalProps;
    const [openPanelOrder, setOpenPanelOrder] = useState(false);

    const handleCancelClick = () => {
        closeModal();
    };

    const hidePanelOrderItem = () => {
        setOpenPanelOrder(false);
    };

    // Cols def
    const cols: GridColDef[] = [
        {
            field: "assetId",
            headerName: t("table:headerName.idAsset"),
            flex: CellSize.medium,
            minWidth: CellSize.medium,
        },
        {
            field: "state",
            headerName: t("common:state"),
            flex: CellSize.small,
            minWidth: CellSize.small,
            renderCell: (data: any) => (data.value ? <Chip label={data.value} /> : <></>),
        },
        {
            field: "type",
            headerName: t("common:type"),
            flex: CellSize.large,
            minWidth: CellSize.large,
            renderCell: (data: any) => (data.value ? <Chip label={data.value} sx={{ mt: 0.5, mb: 0.5 }} /> : <></>),
        },
        {
            field: "note",
            headerName: t("common:note"),
            flex: CellSize.large,
            minWidth: CellSize.large,
        },
        {
            field: "price",
            headerName: t("common:price"),
            flex: CellSize.large,
            minWidth: CellSize.large,
        },
    ];

    return (
        <Modal
            title={expense.note + (UserHasAcl(AclTypes.aclSuperUser) ? " - #" + expense.id : "")}
            reference={ref}
            closeModal={handleCancelClick}
            width={1300}
        >
            <Stack px={2} maxHeight={600}>
                {expense.orderItemId && (
                    <>
                        <Stack>
                            <Grid container spacing={1} pt={0} mb={1}>
                                <Grid item md={6} pt={0}>
                                    <InputLabel sx={{ mb: 1 }}>{t("field:label.titleName")}</InputLabel>
                                    <Chip label={expense.titleName} />
                                </Grid>
                                <Grid item md={6} pt={0}>
                                    <Typography></Typography>
                                    <InputLabel sx={{ mb: 1 }}>{t("field:label.orderItemId")}</InputLabel>

                                    <Chip
                                        label={expense.orderItemId}
                                        onClick={() => {
                                            setOpenPanelOrder(true);
                                        }}
                                    />
                                </Grid>
                                <Grid item md={6} pt={0}>
                                    <InputLabel sx={{ mb: 1 }}>{t("field:label.orderReference")}</InputLabel>
                                    <OutlinedInput value={expense.orderReference} disabled={true} />
                                </Grid>
                                <Grid item md={6} pt={0}>
                                    <InputLabel sx={{ mb: 1 }}>{t("field:label.orderPrice")}</InputLabel>
                                    <OutlinedInput value={expense.orderPrice} disabled={true} />
                                </Grid>
                                <Grid item md={6} pt={0}>
                                    <InputLabel sx={{ mb: 1 }}>{t("field:label.orderNote")}</InputLabel>
                                    <OutlinedInput value={expense.orderNote} disabled={true} />
                                </Grid>
                                <Grid item md={6} pt={0}>
                                    <InputLabel sx={{ mb: 1 }}>{t("field:label.orderCustomer")}</InputLabel>
                                    <OutlinedInput value={expense.orderCustomer} disabled={true} />
                                </Grid>
                            </Grid>
                        </Stack>
                        <OrderItemPanel open={openPanelOrder} onClose={hidePanelOrderItem} itemId={expense.orderItemId} />
                    </>
                )}
                <DataTable
                    noControls
                    rows={expense.models ?? []}
                    columns={cols}
                    columnHeaderHeight={48}
                    rowHeight={56}
                    getRowHeight={() => "auto"}
                    checkboxSelection={false}
                    disableRowSelectionOnClick
                    pagination={true}
                    getRowId={(row) => row.type + "" + row.price}
                    defaultGroupingExpansionDepth={-1}
                    initialState={{
                        rowGrouping: {
                            model: [expense.tag === ExpenseTag.Storage ? "assetId" : ""],
                        },
                    }}
                    columnVisibilityModel={{
                        assetId: false,
                        note: expense.tag === ExpenseTag.Storage,
                    }}
                />
            </Stack>
        </Modal>
    );
});

export default ModalBillingExpense;
